import Alert from './alert';
import AlertBanner from './banner';
var AlertExport = Alert;
AlertExport.Banner = AlertBanner;
export * from './interface';
export default AlertExport;
